

















































import Vue from 'vue'
import { octaves as allowedOctaves } from '@/application/models/octaves'
import { TRIAD, SEVENTH } from '../application/models/chords'


export default Vue.extend({
  data() {
    return {
      degrees: [1, 4, 5],
      inversions: true,
      octaves: [2, 3],
      variants: [TRIAD],

      allowedDegrees: [1,2,3,4,5,6,7],
      allowedOctaves,
      allowedVariants: [TRIAD, SEVENTH].map(v => v.toString())
    }
  },
  watch: {
    variants() {
      if(this.variants.length === 0) {
        this.variants = [TRIAD]
      }
    },
    octaves() {
      if(this.octaves.length === 0) {
        this.octaves = [3]
      }
    }
  },
  methods: {
    onSubmit() {
      if(this.degrees.length === 0) return
      
      this.$router.push({name: 'Training', query: {
        degrees: this.degrees.length ? this.degrees.filter(d => !!d).join(',') : undefined,
        inversions: this.inversions ? this.inversions.toString() : undefined,
        octaves: this.octaves.length ? this.octaves.join(',') : undefined,
        variants: this.variants.length ? this.variants.join(',') : undefined,
        custom: 'true'
      }})
    }
  }
})
